'use client';
import FullscreenExitRoundedIcon from '@mui/icons-material/FullscreenExitRounded';
import { MapSearchInput } from '@wt/app/admin/_components/EditRoundForm';
import { MapCoordinate } from '@wt/shared/components/maps/mapkit/types';
import MapElement from '@wt/shared/components/maps/mapkit/map';
import useKeypress from '@wt/shared/hooks/useKeyPress';
import { isChecked } from '@wt/shared/hooks/utils/isChecked';
import { MapInteractionEvent } from '@wt/shared/libs/mapkit';

import ModalLayout from '../layouts/ModalLayout';
import { smallButtonClasses } from '@wt/shared/components/buttons/SmallButton';

interface MapModalProps {
  id: string;
  onLocationSelect?: (e: MapInteractionEvent | MapCoordinate) => void;
  selectedLocation?: MapCoordinate | undefined;
  label?: string;
  showSearchBar?: boolean;
  mapSearchInput?: string;
  setMapSearchInput?: (e: string) => void;
}

export const MapModal = ({
  id,
  selectedLocation,
  onLocationSelect,
  label,
  showSearchBar,
  mapSearchInput,
  setMapSearchInput,
}: MapModalProps) => {
  useKeypress('Escape', () => {
    const t = document.getElementById(id);
    t && isChecked(t) && t.click();
  });

  return (
    <ModalLayout htmlFor={id}>
      <div className="absolute inset-0">
        <MapElement
          selectedLocation={selectedLocation}
          onLocationSelect={onLocationSelect}
          label={label}
          inModal={true}
        />
      </div>
      <label
        htmlFor={id}
        className={`pointer-events-auto absolute right-4 top-4 z-[99] ${smallButtonClasses}`}
      >
        <FullscreenExitRoundedIcon htmlColor="black" />
      </label>
      {showSearchBar &&
        mapSearchInput !== undefined &&
        setMapSearchInput !== undefined &&
        onLocationSelect !== undefined && (
          <MapSearchInput
            mapSearchInput={mapSearchInput}
            setMapSearchInput={setMapSearchInput}
            handleChangeLocation={onLocationSelect}
          />
        )}
    </ModalLayout>
  );
};

export default MapModal;
